import { compareValues, getActiveJobSets, mergeFilters, simulateApiWait } from "../../../common/fakeJobsUtils"
import { Job, JobFilter, JobKey, JobOrder } from "../../../models/lookoutModels"

import { GetJobsResponse, IGetJobsService } from "../GetJobsService"

export default class FakeGetJobsService implements IGetJobsService {
  constructor(
    private jobs: Job[],
    private simulateApiWait = true,
  ) {}

  async getJobs(
    _: GlobalFetch["fetch"],
    filters: JobFilter[],
    activeJobSets: boolean,
    order: JobOrder,
    skip: number,
    take: number,
    signal?: AbortSignal,
  ): Promise<GetJobsResponse> {
    if (this.simulateApiWait) {
      await simulateApiWait(signal)
    }

    let filtered = this.jobs.filter(mergeFilters(filters)).sort(comparator(order))
    if (activeJobSets) {
      const active = getActiveJobSets(filtered)
      filtered = filtered.filter((job) => job.queue in active && active[job.queue].includes(job.jobSet))
    }
    return {
      jobs: filtered.slice(skip, skip + take),
    }
  }
}

function comparator(order: JobOrder): (a: Job, b: Job) => number {
  return (a, b) => {
    const field = order.field as JobKey
    const valueA = a[field]
    const valueB = b[field]

    if (valueA === undefined || valueB === undefined) {
      // eslint-disable-next-line no-console
      console.error("comparator values are undefined")
      return 0
    }

    return compareValues(valueA, valueB, order.direction)
  }
}
